<template>
  <el-dialog
    title="产品入库"
    :visible="visible"
    @close="onClose"
    @open="onOpen"
    width="40%"
    :close-on-click-modal="false">
    <el-form :model="item" ref="itemform" label-width="120px" :rules="rules">
      <el-form-item label="产品型号" prop="DciProductModelID">
        <select2
          style="width: 100%"
          labelName="NameNumber"
          v-model="item.DciProductModelID"
          url="dci/model/product/list?order=name"
          :clearable="false"
          placeholder="请选择产品型号"
          no-data-text="没有产品型号"
          :urlParams="{
            where: {},
          }"
          q="NameNumber:like"
          :qinwhere="true"
          :queryOne="false"
        ></select2>
      </el-form-item>
      <el-form-item label="生产批次" prop="ProductionBatch">
        <el-input v-model.trim="item.ProductionBatch" placeholder="请输入生产批次"></el-input>
      </el-form-item>
      <el-form-item label="开始编号" prop="Nstart">
        <el-input-number v-model="item.Nstart" :min="1"></el-input-number>
      </el-form-item>
      <el-form-item label="结束编号" prop="Nend">
        <el-input-number v-model="item.Nend" :min="1"></el-input-number>
      </el-form-item>
      <el-form-item label="入库日期" prop="StockinAt">
        <el-date-picker
          v-model="item.StockinAt"
          style="width:100%"
          type="date"
          placeholder="选择日期"
        ></el-date-picker>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="onClose">
        <i class="fas fa-times"></i> 取 消
      </el-button>
      <el-button type="primary" @click="onSubmit" :disabled="submitting">
        <i class="far fa-save"></i> 确 定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>

export default {
  props: {
    value: Object,
    visible: Boolean,
  },
  data() {
    return {
      item: _.clone(this.value),
      rules: {
        DciProductModelID: [
          { required: true, message: '产品型号不能为空', trigger: 'blur' },
        ],
        ProductionBatch: [
          { required: true, message: '生产批次不能为空', trigger: 'blur' },
        ],
        Nstart: [
          { required: true, message: '开始编号不能为空', trigger: 'blur' },
        ],
        Nend: [
          { required: true, message: '结束编号不能为空', trigger: 'blur' },
        ],
        StockinAt: [
          { required: true, message: '入库日期不能为空', trigger: 'blur' },
        ],
      },
      submitting: false,
    };
  },
  methods: {
    onOpen() {
      this.item = _.cloneDeep(this.value);
    },
    onClose() {
      this.$emit('update:visible', false);
      this.$emit('cancel');
      this.$refs.itemform.resetFields();
    },
    onSubmit() {
      this.$refs.itemform.validate((valid) => {
        if (!valid) {
          return;
        }
        this.submitting = true;
        this.$emit('input', this.item);
        const itemData = { ...this.item };
        this.$axios.request({
          url: 'dci/product/stock-in',
          method: 'post',
          data: itemData,
        }).then(() => {
          this.$message.success('入库成功');
          this.submitting = false;
          this.$emit('form:created', true);
          this.$emit('form:saved', true);
          this.$emit('update:visible', false);
        }).catch(({ response }) => {
          this.$sys.alarmResponse(response);
          this.submitting = false;
          this.$emit('form:created', false);
          this.$emit('form:saved', false);
        });
      });
    },
  },
};
</script>
